// src/mocks/handlers/afipQueue.handlers.js
import * as data from '../data/afipQueue.demo';

export const getHealth      = async () => data.health;
export const getStats       = async () => data.stats;
export const getMyInvoices  = async () => data.myInvoices;
export const syncProcessing = async () => ({ synced: 0, failed: 0, skipped: 0, message: 'No hay facturas en procesamiento' });
export const getQueue       = async () => data.queue;
